(() => {
const dialog=document.getElementById('claire-cart-confirm');if(!dialog)return;
let opener;
function show(workshop=false){
 opener=document.activeElement;
 document.querySelectorAll('cart-drawer-component dialog[open]').forEach(d=>d.close());
 dialog.querySelector('[data-workshop-confirm]').hidden=!workshop;
 if(!dialog.open)dialog.showModal();
 dialog.querySelector('[data-cart-link]').focus();
}
dialog.querySelector('[data-continue]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>{if(opener?.isConnected)opener.focus();});
document.addEventListener('cart:update',e=>{if(e.detail?.data?.source==='product-form-component'&&!e.detail.data.didError)show(false);});
document.addEventListener('claire:workshop-added',()=>show(true));
function hints(){
 document.querySelectorAll('.cb-form').forEach(f=>{
  if(f.querySelector('.claire-voucher-help'))return;
  const b=f.querySelector('button');if(!b)return;
  b.textContent=document.documentElement.lang.startsWith('nl')?'Toevoegen aan winkelwagen':'Add to cart';
  b.before(document.getElementById('claire-voucher-help-template').content.cloneNode(true));
 });
}
hints();new MutationObserver(hints).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
})();